import { INumberIdEntity } from "../base.interface";

export interface ICompany extends INumberIdEntity {
    legalName: string;
    brandName: string;
    companyType: CompanyTypes;
    country: string;
    isActive: boolean;
    vatNumber?: string;
}

export type CompanyTypes = "PRIVATE_COMPANY" | "PUBLIC_ENTITY" | "UTILITY" | "OPERATOR" | "OTHER";
// Essendo company role codes generati dinamicamente da backoffice, non possiamo usare un enum typescript
export const RoleCodes = {
    CPO: "CPO",
    EMSP: "EMSP",
    HUB_OPERATOR: "HUB_OPERATOR",
    POD_OWNER: "POD_OWNER",
    INSTALLATION_OWNER: "INSTALLATION_OWNER",
    STATION_OWNER: "STATION_OWNER",
    SPONSOR_COMPANY: "SPONSOR_COMPANY",
}

export type RoleCodesType = typeof RoleCodes[keyof typeof RoleCodes];

export interface IRole extends INumberIdEntity {
    code: string; // Unico ! Generabili dinamicamente da backoffice 
    name: string;
    description?: string;
}

export interface ICreateCompanyDTO {
    legalName: string;
    companyType: string;
    brandName: string;
    vatNumber: string;
    country: string;
    isActive: boolean;
}

export interface IUpdateCompanyDTO extends Partial<ICreateCompanyDTO> {}

export interface ICreateRoleDTO {
    name: string;
    code: string;
    description: string;
}

export interface IUpdateRoleDTO extends Partial<ICreateRoleDTO> {}

export interface ICompanyRole extends INumberIdEntity {
    companyId: number;
    roleId: number;
    activeFrom: Date | string;
    activeTo?: Date | string | null;
    status: string;
    notes?: string | null;
    name: string;
    commercialName?: string | null;
    operatorId?: string | null;
    providerId?: string | null;
    country?: string | null;
    company?: ICompany;
    role?: IRole;
}

export interface ICreateCompanyRoleDTO {
    companyId: number;
    roleId: number;
    activeFrom: Date | string;
    activeTo?: Date | string | null;
    status: string;
    notes?: string | null;
    name: string;
    commercialName?: string | null;
    operatorId?: string | null;
    providerId?: string | null;
    country?: string | null;
}

export interface IUpdateCompanyRoleDTO extends Partial<ICreateCompanyRoleDTO> {}

export interface IAssignRetailTariffDTO {
    tariffId: string;
}

export interface ICompanyRelationsSummary {
    companyRolesCount: number;
    sponsorshipPoliciesCount: number;
    activeSponsorshipPoliciesCount: number;
    coverageRulesCount: number;
    coverageRuleLimitsCount: number;
    policyGroupUsersCount: number;
}

export interface ICompanyCostSummary {
    companyPaidTotal: number;
    usersPaidTotal: number;
    sponsoredTotal: number;
    allocationsCount: number;
    companyPayerAllocationsCount: number;
    userPayerAllocationsCount: number;
    currencies: string[];
}

export interface ICompanyDetailSummary {
    company: ICompany;
    relations: ICompanyRelationsSummary;
    costs: ICompanyCostSummary;
}
